import React from "react";
import { useTranslation } from "react-i18next";

export default function DashboardMetric({
  label,
  icon,
  value,
  detail,
  title,
  action,
  loading = false,
}: {
  label: string;
  icon?: React.ReactNode;
  value: React.ReactNode;
  detail?: React.ReactNode;
  title?: string;
  action?: React.ReactNode;
  loading?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div
      className={`min-w-0 ${icon ? "grid grid-cols-[2rem_minmax(0,1fr)] gap-x-2.5" : "py-3"}`}
      title={title}
    >
      {icon && <div className="row-span-3">{icon}</div>}
      <div className={`flex items-center text-sm text-text-dim ${icon ? "min-h-8" : ""}`}>
        {label}
      </div>
      <div
        className={`${icon ? "mt-1" : "mt-2"} flex min-h-9 flex-wrap items-center gap-x-3 gap-y-2`}
      >
        <div className="flex items-center font-display text-3xl font-semibold tabular-nums tracking-tight text-text">
          {loading ? (
            <span
              aria-label={t("loading")}
              className="h-8 w-20 animate-pulse rounded bg-muted-surface"
            />
          ) : value == null ? (
            <span className="text-base font-normal tracking-normal text-text-dim">
              {t("dashboard.no_data")}
            </span>
          ) : (
            value
          )}
        </div>
        {action}
      </div>
      {detail && (
        <div
          className={`${icon ? "mt-1" : "mt-2"} truncate text-sm text-text-mid`}
          title={typeof detail === "string" ? detail : undefined}
        >
          {detail}
        </div>
      )}
    </div>
  );
}
